module.exports = __webpack_public_path__ + "img/box_pro_four_1.d5ddf618.jpg";